import { Record, Map } from 'immutable'
import * as actionTypes from './actionTypes'

const UpdateState = Record({
  ongoing: false,
  success: false,
  error: null,
})

const InitialState = Record(
  {
    map: Map(),
    joined: Map(),
    error: null,
    updateOrganization: UpdateState(),
    updateOrganizationPhoto: UpdateState(),
  },
  'organizations'
)

const OrganizationsReducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case actionTypes.ORGANIZATION_JOINED_FETCHED:
      const organizationPublic = action.payload
      return state.update('joined', joined =>
        joined.set(organizationPublic.id, organizationPublic)
      )
    case actionTypes.ORGANIZATION_FETCH_ERROR:
      const error = action.payload
      return state.set('error', error)
    case actionTypes.UPDATE_ORGANIZATION_START: {
      return state.set('updateOrganization', new UpdateState({ ongoing: true }))
    }
    case actionTypes.UPDATE_ORGANIZATION_SUCCESS: {
      return state.set(
        'updateOrganization',
        new UpdateState({ ongoing: false, success: true })
      )
    }
    case actionTypes.UPDATE_ORGANIZATION_ERROR: {
      const error = action.payload
      return state.set(
        'updateOrganization',
        new UpdateState({ ongoing: false, error })
      )
    }
    case actionTypes.UPDATE_ORGANIZATION_PHOTO_START: {
      return state.set(
        'updateOrganizationPhoto',
        new UpdateState({ ongoing: true })
      )
    }
    case actionTypes.UPDATE_ORGANIZATION_PHOTO_SUCCESS: {
      return state.set(
        'updateOrganizationPhoto',
        new UpdateState({ ongoing: false, success: true })
      )
    }
    default:
      return state
  }
}

export default OrganizationsReducer
